import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { CategoriesWithProduct } from 'app/_models/categories';
import { Observable, Subject } from 'rxjs';
import { UserModel } from 'app/_models/user-model';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CrudCategoryService {
  private readonly _baseUrl: string;
  private readonly _refreshrequired = new Subject<void>();
  constructor(private readonly http: HttpClient) {
    this._baseUrl = environment.baseUrl;
   }
   currentUser: UserModel;

   get Refreshrequired() {
    return this._refreshrequired;
  }
  
  getAllCategoriesWithProducts() {

    return this.http.get<CategoriesWithProduct[]>(this._baseUrl + 'Product/GetAllActiveCategoriesWithProducts');
  }
  
  getPagedAllCategoriesWithProducts(model:any): Observable<any>{
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
    let options = { headers: headers,  withCredentials: true  };
    return this.http.post<any>(`${this._baseUrl}Product/GetAllActiveCategoriesWithProducts`, model, options);
  }

deleteCategory(id:number): Observable<any> {
  this.currentUser = JSON.parse(sessionStorage.getItem('user'));
  let model = {id: id, updatedBy: this.currentUser.userId}
    return this.http.post<any>(this._baseUrl +'Product/DeleteCategory', model).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
  }

  addCategory(productId:number, categoryName:string, description:string): Observable<any> {
    this.currentUser = JSON.parse(sessionStorage.getItem('user'));
    let model = {productId: productId,categoryName:categoryName, description:description, createdBy: this.currentUser.userId}
      return this.http.post<any>(this._baseUrl +'Product/AddProductCategory', model).pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
    }

    updateCategory(model:any): Observable<any> {
      this.currentUser = JSON.parse(sessionStorage.getItem('user'));
        return this.http.post<any>(this._baseUrl +'Product/UpdateCategory', model).pipe(
          tap(() => {
            this.Refreshrequired.next();
          })
        );
      }

}
 